export default __webpack_public_path__ + "static/media/document_upload.fd103340.svg";